export enum SmsTriggers {
  DIRECT = 'direct',
  JOB = 'job',
  MANUAL = 'manual',
}
